<template>
  <el-card>
    <el-form inline ref="searchForm" :model="searchForm">
      <el-form-item prop="serviceName">
        <el-input v-model="searchForm.serviceName" placeholder="请输入服务名称" clearable></el-input>
      </el-form-item>
      <el-form-item prop="projectName">
        <el-input v-model="searchForm.projectName" placeholder="请输入公园名称" clearable></el-input>
      </el-form-item>
      <el-form-item prop="typeId">
        <el-select v-model="searchForm.typeId" placeholder="请选择服务类型" filterable clearable>
          <el-option v-for="item in serviceList" :key="item.typeId" :label="item.typeName"
            :value="item.typeId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>

    <div class="mb20">
      <el-button @click="onAdd" type="primary" icon="el-icon-plus" v-if="$ButtonShow('SER_ADD_01')">添加服务</el-button>
      <el-button @click="onType" type="primary">服务类型</el-button>
    </div>

    <el-table class="global-table" v-loading="loading" :data="tableData">
      <el-table-column label="服务名称" show-overflow-tooltip prop="serviceName"></el-table-column>
      <el-table-column label="服务类型" show-overflow-tooltip prop="typeName"></el-table-column>
      <el-table-column label="所属公园" show-overflow-tooltip prop="projectName"></el-table-column>
      <el-table-column label="编号" show-overflow-tooltip prop="serviceFacilitiesCode"></el-table-column>
      <el-table-column label="操作" width="150px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click="onDetail(row)">查看</el-button>
          <el-button type="text" @click="onUpdate(row)" v-if="$ButtonShow('SER_EDT_01')">编辑</el-button>
          <el-button type="text" @click="onDelete(row.serviceId)" v-if="$ButtonShow('SER_DEL_01')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <GlobalPagination @size-change="loadData" @current-change="loadData" :current-page.sync="page"
      :page-size.sync="size" :total="total">
    </GlobalPagination>
    <ServiceType :isShowType.sync='isShowType' @updateType="getTypeList()"></ServiceType>
  </el-card>
</template>

<script>
import ServiceType from './ServiceType'
import keepAlive from '@/mixins/keepAlive.js'
export default {
  name: 'Inparkservice',
  mixins: [keepAlive],
  components: {
    ServiceType
  },
  data() {
    return {
      page: 1,
      size: 10,
      total: 0,
      loading: false,
      tableData: [],
      searchForm: {
        typeId: '',
        projectName: ''
      },
      isShowType: false,
      serviceList: []
    }
  },
  created() {
    this.loadData()
    this.getTypeList()
  },
  methods: {
    getTypeList() {
      this.$axios.get(this.$apis.tourist.selectServiceTypeByList).then(res => {
        this.serviceList = res.list || []
      }).finally(() => {
        this.loading = false
      })
    },
    onType() {
      this.isShowType = true
    },
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.tourist.selectServiceFacilitiesByPage, {
        page: this.page,
        size: this.size,
        ...this.searchForm
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onAdd() {
      this.$router.push('/inparkservice/add')
    },
    onUpdate(item) {
      this.$router.push({
        name: 'InparkserviceUpdate',
        params: { id: item.serviceId },
        query: {
          projectId: item.projectId
        }
      })
    },
    onDetail(item) {
      this.$router.push({
        name: 'InparkserviceDetail',
        params: { id: item.serviceId },
        query: {
          projectId: item.projectId
        }
      })
    },
    onDelete(serviceId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.tourist.deleteServiceFacilities, {
          serviceId
        }).then(() => {
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'></style>
